import { Box, Stack, useBreakpoint } from '@resi-media/resi-ui';
import { useParams } from 'react-router';
import { LiveVideoDetails } from '@sites/components/LiveVideoDetails';
import { VideoHeader } from '@sites/components/VideoHeader';
import { VideoPlayerSection } from '@sites/components/VideoPlayerSection';
import { PAGE_TYPES } from '@sites/constants/generic';
import { HEADER_PADDING_X, MOBILE_HEADER_PADDING_X } from '@sites/constants/layout';
import { useLivePlayer } from '@sites/contexts/livePlayerContext';
import { useQueryParams } from '@sites/contexts/queryContext';

const LiveVideo = () => {
  const mediaQuery = useBreakpoint();
  const { isLoading } = useLivePlayer();
  const { webChannelId } = useParams<'webChannelId'>();
  const { isEmbed } = useQueryParams();

  return (
    <Box dataTestId="live-video-test-id" id="live-video-id" mb="m" mt={isEmbed ? 'x20' : 'xl'}>
      <Stack gap={mediaQuery.lg ? 'xl' : 'm'} px={{ xs: MOBILE_HEADER_PADDING_X, lg: HEADER_PADDING_X }} py={0}>
        <VideoHeader isLoading={isLoading} variant={PAGE_TYPES.LIVE} />
        <Stack gap="l">
          <VideoPlayerSection isLoading={isLoading} variant={PAGE_TYPES.LIVE} webChannelId={webChannelId} />
          <LiveVideoDetails />
        </Stack>
      </Stack>
    </Box>
  );
};

LiveVideo.displayName = 'LiveVideo';

export default LiveVideo;
